import Vue from 'vue'
import VueRouter from 'vue-router'
import AppListPC from "../views/appList/AppListPC";
import AppListMobile from "../views/appList/AppListMobile";
import userLogInMobile from "../views/login/userLogInMobile";
import noAuth from "../views/noAuth";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'view',
    component: () => import('../views/generalTemplate')
  },

  {
    path: '/userLogInPC',
    name: 'userLogInPC',
    component: () => import('../views/login/userLogInPC')
  },

  {
    path: '/dhd_services',
    name: 'dhd_service',
    component: () => import('../views/login/dhd_service')
  },

  {
    path: '/userLogInMobile',
    name: 'userLogInMobile',
    component: userLogInMobile
  },

  {
    path: '/AppListPC',
    name: 'AppListPC',
    component: AppListPC
  }
  ,

  {
    path: '/AppListMobile',
    name: 'AppListMobile',
    component: AppListMobile
  },

  {
    path: '/noAuth',
    name: 'noAuth',
    component: noAuth
  }

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
